import React from "react";
import "./AP.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Foto_About/Kanan_Atas.png";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281220003574&text=Halo%20Lenny,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20(Residentials)%20https://sinarmaskotawisata.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutresidential" id="residentials">
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
      <div className="containerabout">
        <h1>Our Residentials</h1>
        <div className="container-desk">
          <div className="desk">
            Kota Wisata Cibubur memiliki beragam cluster hunian yang
            menyesuaikan kebutuhan dan gaya hidup masyarakat modern. Setiap
            cluster mengusung desain arsitektur yang elegan dan berbeda, seperti
            gaya modern tropis, Eropa klasik, dan minimalis kontemporer.
            Fasilitas kawasan Kota Wisata Cibubur sangat lengkap, mencakup
            kebutuhan gaya hidup, pendidikan, kesehatan, dan hiburan.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Clubhouse & Swimming Pool
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Children Playground
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;One Gate System
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Jogging Track
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(182, 139, 78)" />
              <span style={{color: "rgb(53, 52, 52)"}}>
                &nbsp;&nbsp;Security 24 Hours
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
